<template>
  <div class="load-detail">
    <keep-alive>
      <edit/>
    </keep-alive>
  </div>
</template>
<script>
  import edit from './edit';

  export default {
    name: 'adminBillLadingLading',
    components: {
      edit,
    },
    data() {
      return {
        start: true,
      };
    },
    watch: {
      // '$route.name': function() {
      //   this.start = false;
      //   this.$nextTick(() => {
      //     this.start = true;
      //   });
      // },
    },
  };
</script>
<style>
  .load-detail {
    width: 100%;
  }
</style>
